(function () {
  var MAX_EDGE = 1280;
  var JPEG_QUALITY = 0.72;
  var SUBMIT_FLAG = 'ccf-form-submitted';
  var RELOAD_FLAG = 'ccf-form-reloaded';
  var SUBMIT_WINDOW_MS = 60000;

  function formatBytes(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function loadImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('Could not read image'));
      };
      img.src = url;
    });
  }

  function compressImage(file) {
    return loadImage(file).then(function (img) {
      var width = img.naturalWidth || img.width;
      var height = img.naturalHeight || img.height;
      var scale = Math.min(1, MAX_EDGE / Math.max(width, height));
      var targetW = Math.max(1, Math.round(width * scale));
      var targetH = Math.max(1, Math.round(height * scale));
      var canvas = document.createElement('canvas');
      canvas.width = targetW;
      canvas.height = targetH;
      var ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Could not process image');
      ctx.drawImage(img, 0, 0, targetW, targetH);
      return canvas.toDataURL('image/jpeg', JPEG_QUALITY);
    });
  }

  function storageGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function storageRemove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }

  function clearThemeScrollRestore() {
    try {
      sessionStorage.removeItem('scrollPosition_' + window.location.pathname);
    } catch (e) {}
  }

  function hasContactPostedParam() {
    try {
      return new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    } catch (e) {
      return /[?&]contact_posted=true(?:&|$)/.test(window.location.search);
    }
  }

  function focusFeedback(el) {
    if (!el) return;
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      try {
        el.focus();
      } catch (err) {}
    }
    if (typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function getSuccessText(root) {
    var existing = root.querySelector('[data-ccf-success]');
    if (existing && existing.textContent) return existing.textContent.trim();
    var fromAttr = root.getAttribute('data-ccf-success-text');
    if (fromAttr) return fromAttr;
    return 'Thanks for contacting us. We\'ll get back to you as soon as possible.';
  }

  function ensureSuccessMessage(root) {
    var feedback = root.querySelector('[data-ccf-feedback]');
    if (!feedback) return null;

    var success = feedback.querySelector('[data-ccf-success]');
    if (success) return success;

    success = document.createElement('p');
    success.className = 'custom-contact-form__status custom-contact-form__status--success';
    success.setAttribute('role', 'status');
    success.setAttribute('data-ccf-success', '');
    success.textContent = getSuccessText(root);
    feedback.prepend(success);
    feedback.setAttribute('tabindex', '-1');
    return success;
  }

  function findVisibleFeedback(root) {
    return (
      root.querySelector('[data-ccf-success]') ||
      root.querySelector('[data-ccf-errors]') ||
      root.querySelector('.custom-contact-form__status') ||
      root.querySelector('.custom-contact-form__errors .errors, .custom-contact-form__errors ul')
    );
  }

  function wasRecentSubmit() {
    var raw = storageGet(SUBMIT_FLAG);
    if (!raw) return false;
    var submittedAt = parseInt(raw, 10);
    if (!submittedAt) return true;
    return Date.now() - submittedAt < SUBMIT_WINDOW_MS;
  }

  function revealPostSubmitFeedback(root) {
    var feedbackRoot = root.querySelector('[data-ccf-feedback]') || root;
    var feedback = findVisibleFeedback(root);
    var posted = hasContactPostedParam();
    var wasSubmitted = wasRecentSubmit();
    var alreadyReloaded = !!storageGet(RELOAD_FLAG);

    if (storageGet(SUBMIT_FLAG)) storageRemove(SUBMIT_FLAG);

    if (!feedback && posted) {
      feedback = ensureSuccessMessage(root);
    }

    if (feedback) {
      storageRemove(RELOAD_FLAG);
      focusFeedback(feedbackRoot.querySelector('[data-ccf-feedback]') || feedback);
      return;
    }

    // Shopify sometimes serves a cached first paint without form.errors /
    // posted_successfully. A single reload recovers the flash message.
    if (wasSubmitted && !alreadyReloaded) {
      storageSet(RELOAD_FLAG, '1');
      window.location.reload();
      return;
    }

    storageRemove(RELOAD_FLAG);
  }

  function initForm(root) {
    if (root.getAttribute('data-ccf-form-ready') === 'true') return;
    root.setAttribute('data-ccf-form-ready', 'true');

    var form = root.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function () {
      clearThemeScrollRestore();
      storageSet(SUBMIT_FLAG, String(Date.now()));
      storageRemove(RELOAD_FLAG);
    });

    revealPostSubmitFeedback(root);
  }

  function initAttach(root) {
    if (root.getAttribute('data-ccf-ready') === 'true') return;
    root.setAttribute('data-ccf-ready', 'true');

    var input = root.querySelector('[data-ccf-file]');
    var trigger = root.querySelector('.custom-contact-form__attach-trigger');
    var selected = root.querySelector('[data-ccf-file-selected]');
    var label = root.querySelector('[data-ccf-file-label]');
    var clearBtn = root.querySelector('[data-ccf-file-clear]');
    var errorEl = root.querySelector('[data-ccf-file-error]');
    var nameField = root.querySelector('[data-ccf-file-name]');
    var dataField = root.querySelector('[data-ccf-file-data]');
    var maxSize = parseInt(root.getAttribute('data-max-size') || '2097152', 10);
    var compressing = false;

    if (!input || !trigger || !selected || !label || !clearBtn || !nameField || !dataField) return;

    function setError(message) {
      if (!errorEl) return;
      if (message) {
        errorEl.textContent = message;
        errorEl.classList.add('is-visible');
      } else {
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }
    }

    function clearFile() {
      input.value = '';
      nameField.value = '';
      dataField.value = '';
      label.textContent = '';
      root.classList.remove('is-uploaded');
      compressing = false;
      setError('');
    }

    function showSelected(fileName) {
      label.textContent = fileName;
      root.classList.add('is-uploaded');
    }

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      setError('');

      if (!file) {
        clearFile();
        return;
      }

      if (!file.type || file.type.indexOf('image/') !== 0) {
        clearFile();
        setError('Please choose an image file.');
        return;
      }

      if (file.size > maxSize) {
        clearFile();
        setError('Image is too large. Max size is ' + formatBytes(maxSize) + '.');
        return;
      }

      compressing = true;
      compressImage(file)
        .then(function (dataUrl) {
          nameField.value = file.name;
          dataField.value = dataUrl;
          showSelected(file.name);
        })
        .catch(function () {
          clearFile();
          setError('Could not attach that image. Please try another file.');
        })
        .then(function () {
          compressing = false;
        });
    });

    clearBtn.addEventListener('click', function (event) {
      event.preventDefault();
      clearFile();
    });

    var form = root.closest('form');
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!compressing) return;
        event.preventDefault();
        setError('Please wait for the image to finish attaching.');
      });
    }
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-section-type="custom-contact-form"]').forEach(initForm);
    context.querySelectorAll('[data-ccf-attach]').forEach(initAttach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });

  // bfcache can restore a pre-submit document while the URL already has
  // contact_posted=true. Force a fresh render so the success state appears.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (!hasContactPostedParam()) return;
    window.location.reload();
  });
})();
